import { OrgDialogService } from './services/org-dialog.service';
import { Component, inject, Input, OnInit } from '@angular/core';
import { Organization } from '@newgenus/common';

/**
 * Base component class with no template.
 * Used to create a base class for all components in the Orb Board.
 *
 * Includes shared services, properties, styling, etc.
 */
@Component({
    selector: 'shared-org-board-base-component',
    template: ``,
    styleUrls: ['./org-board-base-component.scss'],
    standalone: false,
})
export abstract class OrbBoardBaseComponent implements OnInit {
    public dialogService = inject(OrgDialogService);

    @Input() // Required
    public org: Organization | null = null;

    /**
     * Default no-op. Most Orb Board node/sidebar components don't need
     * initialization logic — subclasses override this when they do
     * (e.g. sidebar-position/sidebar-user call `resolveData()` here).
     */
    public ngOnInit(): void {
        return;
    }
}
